import styled from "styled-components";

export const StyledBalanceHistoryWrapper = styled.div`
  .balance-history-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }
  
  .balance-history-table {
    &__head, &__row {
      grid-template-columns: minmax(250px, 1fr) repeat(5, minmax(150px, 1fr)) minmax(250px, 1fr);
    }

    &__amount {
      display: block;
    }
   
    @media screen and (max-width: 992px) {
      min-width: 100%;
      overflow-x: inherit;
      &__head {
        display: none;
      }
      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
    }
  }
`;